import { useEffect, useState } from "react";
import FluxiLogo from "../assets/svg/FluxiLogoWhite.svg";
import GoogleLoginButton from "../components/auth/GoogleLoginButton";
import LoginFormOtherEmail from "../components/auth/LoginFormOtherEmail";
import CodeVerificationStep from "../components/auth/steps/CodeVerificationStep";
import EmailStep from "../components/auth/steps/EmailStep";
import { useSearchParams } from "react-router-dom";
import { dictionary, Language } from "../utils/dictionary";
import { useAuth } from "../context/AuthContext";
export interface UserData {
  email: string;
  verificationCode: string;
}

const LoginPage = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');
  const [open, setOpen] = useState(false)
  const { language } = useAuth();
  const [currentStep, setCurrentStep] = useState(1);
  const [userData, setUserData] = useState<UserData>({
    email: '',
    verificationCode: ''
  });

  useEffect(() => {
    if (email) {
      setOpen(true)
      setCurrentStep(2)
      setUserData({
        email: email,
        verificationCode: ''
      })
    }
  }, [email]);

  const updateUserData = (data: Partial<UserData>) => {
    setUserData(prev => ({ ...prev, ...data }));
  };

  const nextStep = () => {
    setCurrentStep(prev => Math.min(prev + 1, 2));
  };

  const prevStep = () => {
    setCurrentStep(prev => Math.max(prev - 1, 1));
  };

  const handleClose = () => {
    setOpen(false)
    setCurrentStep(1)
    setUserData({
      email: '',
      verificationCode: ''
    })
  }

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <EmailStep
            onClose={handleClose}
            email={userData.email}
            onNext={(email) => {
              updateUserData({ email });
              nextStep();
            }}
          />
        );
      case 2:
        return (
          <CodeVerificationStep
            onClose={handleClose}
            email={userData.email}
            onNext={(code) => {
              updateUserData({ verificationCode: code });
            }}
            onBack={prevStep}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-cover bg-no-repeat"
      style={{
        backgroundImage: "url('/assets/images/login-background.webp')",
      }}
    >
      <div className="flex flex-row max-md:flex-col w-full max-w-[1200px] h-auto md:h-[500px] rounded-2xl overflow-hidden bg-opacity-90 ">
        {/* Left Section */}
        <div className="w-full md:w-1/2 flex flex-col items-center justify-center px-4 md:px-8 text-white">
          <div className="text-center text-white">
            <h1 className="text-[20px] md:text-[32px] lg:text-[36px] font-bold mb-1 leading-tight pt-0 md:pt-0">
              <span className="italic font-semibold">
                Ventas como por
              </span>
            </h1>
            <h2 className="text-[18px] md:text-[28px] lg:text-[32px] italic font-light leading-tight">
              <span className="italic">por arte de mag </span>
              <span className="italic font-bold text-[#85A2FF]">IA</span>
            </h2>
          </div>
        </div>

        {/* Right Section */}
        <div
          className="w-full md:w-[474px] max-w-[90%] px-6 py-4 md:px-[64px] md:py-[20px] flex flex-col items-center justify-center gap-4 rounded-[20px] border-2 border-[#85A2FF] backdrop-blur-md mx-auto md:mx-0"
          style={{
            background: "rgba(255, 255, 255, 0.08)",
            boxSizing: "border-box",
          }}
        >
          <img
            src={FluxiLogo}
            alt="Fluxi Logo"
            className="h-16 md:h-auto mb-2"
          />

          {/* Title Section */}
          {currentStep === 1 && <div className="flex flex-col items-center gap-1">
            <h2 className="text-[24px] md:text-[30px] font-bold text-white text-center">
              Ingresa tu correo
            </h2>
            {/* <p className="text-[16px] md:text-[23px] font-normal text-white text-opacity-75 text-center">
              Login to your account
            </p> */}
          </div>}

          {/* Form Section */}
          {/* <FromLogin /> */}
          {/* <LoginFormOtherEmail setOpen={setOpen} /> */}
          {/* <div className="flex flex-col items-center mt-2">
            <div className="w-full h-[1px] bg-[#E0E0E0] mb-2" />
            <Link
              to="/signup"
              className="text-[#FFFFFF] text-sm md:text-lg font-thin hover:underline"
            >
              Don't have an account? Create an account →
            </Link>
          </div> */}
          {renderStep()}
          {currentStep === 1 && (
            <>
              <div className="flex flex-col items-center justify-center w-[120px]" style={{ border: "1px solid #85A2FF" }}>
              </div>
              <p className="m-0 text-white text-sm">{dictionary["or-sign-in-with"][language]}:</p>
              <GoogleLoginButton />
            </>
          )}
        </div>
      </div>
      {/* {open && ( */}
      {/* <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"> */}
      {/* <div className=" to-blue-50 p-6 rounded-xl font-jakarta max-w-md w-full"> */}
      {/* </div> */}
      {/* </div> */}
      {/* )} */}
    </div>
  );
};

export default LoginPage;